import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import SignIn from "./pages/auth/sign-in";
import SignUp from "./pages/auth/sign-up";
import InqueryForm from "./pages/inquiry/inquery-form";
import ClientDashboard from "./pages/client/ClientDashboard";
import Navbar from "./components/client/Navbar";
import EstimatesPage from "./pages/client/EstimatesPage";
import InvoicePage from './pages/client/InvoicePage';
import TicketsPage from './pages/client/TicketsPage';
import TicketsDetailsPage from "./pages/client/TicketsDetailsPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import UserNavbar from "./components/users/UserNavbar";
import AdminNavbar from "./components/admin/AdminNavbar";
import ManageLeads from "./pages/admin/ManageLeads";
import LeadPage from "./pages/admin/LeadPage";
import ManageTickets from "./pages/admin/tickets/ManageTickets";
import EstimatesDetailsPage from "./pages/client/EstimatesDetailsPage";
import ManageEstimate from "./pages/admin/estimates/ManageEstimate";
import EstimatePage from "./pages/admin/estimates/EstimatePage";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import { useEffect, useState } from "react";
import ManageInvoices from "./pages/admin/invoices/ManageInvoices";
import CutomerPage from "./pages/admin/customer/CutomerPage";
import AdminTicketsPage from "./pages/admin/tickets/AdminTicketsPage";
import AdminCreateLead from "./pages/admin/AdminCreateLead";
import ClientCreateLead from "./pages/client/ClientCreateLead";
import InvoiceDetailsPage from "./pages/client/InvoiceDetailsPage";


function App() {
  const [userRole, setRole] = useState(localStorage.getItem('userType') || '');
  const [isAuthenticated, setIsAuth] = useState(localStorage.getItem('token') || '');
  
  useEffect(() => {
    // Function to handle storage change
    const handleStorageChange = (event) => {
      console.log('event', event)
      if (event.key === 'userType') {
        setRole(event.newValue);
      }
      if(event.key === 'token'){
        setIsAuth(event.newValue);
      }
    };
    const syncLocalStorage = () => {
      console.log('localstorage')
      setRole(localStorage.getItem("userType") || "");
      setIsAuth(localStorage.getItem("token"));
    };

    // Add storage event listener
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener("localstorage-update", syncLocalStorage);
    console.log('lister added.')
    // Cleanup event listener on component unmount
    return () => {
      console.log('LISTENER CLEARED.')
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener("localstorage-update", syncLocalStorage);
    };
  }, []);

  
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/sign-in" />} />
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/inquiry" element={<InqueryForm />} />
      {/* Protected Admin Routes */}
      <Route
        path="/admin/*"
        element={
          isAuthenticated && userRole === "admin" ? (
            <AdminRoutes />
          ) : (
            <Navigate to="/inquiry" />
          )
        }
      />

      {/* Protected Client Routes */}
      <Route
        path="/client/*"
        element={
          isAuthenticated && userRole === "user" ? (
            <ClientRoutes />
          ) : (
            <Navigate to="/inquiry" />
          )
        }
      />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
    </Routes>
  );
}

// Admin routes
const AdminRoutes = () => (
  <>
    <AdminNavbar />
    <Routes>
      <Route path="/" element={<AdminDashboard />} />
      <Route path="/leads" element={<ManageLeads />} />
      <Route path="/leads/:id" element={<LeadPage />} />
      <Route path="/tickets" element={<ManageTickets />} />
      <Route path="/tickets/:id" element={<AdminTicketsPage />} />
      <Route path="/estimates" element={<ManageEstimate />} />
      <Route path="/estimates/:id" element={<EstimatePage />} />
      <Route path="/invoices" element={<ManageInvoices />} />
      <Route path="/createLead" element={<AdminCreateLead />} />
      <Route path="/customer/:id" element={<CutomerPage />} />

    </Routes>
  </>
);

// Client routes
const ClientRoutes = () => (
  <>
    <Navbar />
    <Routes>
      <Route path="/" element={<ClientDashboard />} />
      <Route path="/estimates" element={<EstimatesPage />} />
      <Route path="/estimates/:id" element={<EstimatesDetailsPage />} />
      <Route path="/invoices" element={<InvoicePage />} />
      <Route path="/invoices/:id" element={<InvoiceDetailsPage />} />
      <Route path="/tickets" element={<TicketsPage />} />
      <Route path="/tickets/:id" element={<TicketsDetailsPage />} />
      <Route path="/create-lead" element={<ClientCreateLead />} />
    </Routes>
  </>
);

export default App;
